/**
 * Витягає з тексту фрагменти іноземною мовою для озвучки.
 *
 * «Виберіть правильний переклад для: la gamba» → «la gamba»;
 * «¡Hasta la vista!» → «¡Hasta la vista!»; суто український текст → ''.
 * Токен вважається іноземним, якщо містить літери письма мови курсу і жодної кирилиці;
 * сусідні іноземні токени (і розділові знаки між ними) склеюються в одну фразу.
 */

const CYRILLIC = /[Ѐ-ӿ]/;
const LATIN = /[A-Za-zÀ-ɏ]/;
const SCRIPTS = {
  ko: /[가-힯ᄀ-ᇿ㄰-㆏]/,
  ja: /[぀-ヿ一-鿿]/,
  zh: /[一-鿿]/,
  ar: /[؀-ۿ]/,
};
const ANY_LETTER_OR_DIGIT = /[\p{L}\p{N}]/u;
const ANY_LETTER = /\p{L}/u;
const HOMOGLYPHS = {
  'а': 'a', 'е': 'e', 'о': 'o', 'р': 'p', 'с': 'c', 'у': 'y', 'х': 'x', 'і': 'i', 'ј': 'j', 'ѕ': 's',
  'А': 'A', 'Е': 'E', 'О': 'O', 'Р': 'P', 'С': 'C', 'У': 'Y', 'Х': 'X', 'І': 'I', 'Ј': 'J', 'Ѕ': 'S', 'К': 'K', 'М': 'M', 'Т': 'T', 'В': 'B', 'Н': 'H',
};
const CYRILLIC_ALL = /[Ѐ-ӿ]/g;

const fixMixedToken = (token) => {
  if (!LATIN.test(token) || !CYRILLIC.test(token)) return token;
  const fixed = token.replace(CYRILLIC_ALL, (char) => HOMOGLYPHS[char] || char);

  return CYRILLIC.test(fixed) ? token : fixed;
};

export function extractForeign(text, lang) {
  if (!text) return '';
  const base = String(lang || '').slice(0, 2).toLowerCase();
  if (!base || base === 'uk') return '';

  const script = SCRIPTS[base] || LATIN;
  const isForeign = (token) => script.test(token) && !CYRILLIC.test(token);
  const isPunctuation = (token) => !ANY_LETTER_OR_DIGIT.test(token);

  const runs = [];
  let current = [];
  String(text).split(/\s+/).forEach((rawToken) => {
    if (!rawToken) return;
    const token = script === LATIN ? fixMixedToken(rawToken) : rawToken;
    if (isForeign(token) || (isPunctuation(token) && current.length)) {
      current.push(token);
    } else {
      if (current.length) runs.push(current);
      current = [];
    }
  });
  if (current.length) runs.push(current);

  return runs
    .map((run) => run.join(' ').replace(/^[\s:;,.–—-]+|[\s:;,–—-]+$/g, ''))
    .filter((run) => ANY_LETTER.test(run))
    .join('. ');
}
